<template>
  <download-csv :data="data" :name="fileName" :fields="fields" :labels="labels">
    <v-btn v-bind="size" outlined color="#424242">
      <v-icon>mdi-file-table</v-icon>
    </v-btn>
  </download-csv>
</template>

<script>
export default {
  props: ['size', 'data', 'fields', 'labels', 'fileName'],
};
</script>
